import { render, staticRenderFns } from "./Detail-Tagging.vue?vue&type=template&id=0f8cc45c&"
import script from "./Detail-Tagging.vue?vue&type=script&lang=js&"
export * from "./Detail-Tagging.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports